<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Izveštaj za mašine za period</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="form-label">Period od</label>
            <app-calendar [isNgModel]="true"
                          [(ngModel)]="fromDate"
                          [ngModelOptions]="{standalone:true}"
                          (ngModelChange)="onSelectDateFrom($event)"></app-calendar>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="form-label">Period do</label>
            <app-calendar [isNgModel]="true"
                          [(ngModel)]="toDate"
                          [ngModelOptions]="{standalone:true}"
                          (ngModelChange)="onSelectDateTo($event)"></app-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()">Preuzmi</button>
    </div>
  </div>
</div>
